module.exports = "/_next/static/images/photoCharlesHouser-ec6bdf7bee75f8bf14edca53ea4c0efa.webp";